
// Fadein animation
(function () {
  // Animation title
  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        // Scroll into
        entry.target.classList.add('ces-animated');
      } else {
        entry.target.classList.remove('ces-animated');
      }
    });
  }, {
    root: null,
    rootMargin: '0px',
    threshold: 0.5,
  });
  const list = document.querySelectorAll('.ces-animation-text');
  for (const item of list) {
    observer.observe(item);
  }
})();
